import React from 'react';
import Calendar from '../../components/views/Calendar';
// import HttpServices from '../utils/Http.services';
// import Responsive from '../components/Responsive';
// import { getObject, translate } from '../utils/useful';
// import CalendarSelectScope from '../components/views/CalendarSelectScope';
// import StagesManager from '../components/StagesManager';
// import CalendarDailyView from '../components/views/CalendarDailyView';
// import Week from '../components/views/CalendarWeeklyView';
// import Month from '../components/views/CalendarMonthlyView';
// import SidebarView from '../components/SidebarView';
import Responsive from '../../components/Responsive';
import HttpServices from '../../utils/Http.services';
import { getObject, translate } from '../../utils/useful';
import StagesManager from '../../components/StagesManager';
import CalendarDailyView from '../../components/views/CalendarDailyView';
import Week from '../../components/views/CalendarWeeklyView';
import Month from '../../components/views/CalendarMonthlyView';
import CalendarSelectScope from '../../components/views/CalendarSelectScope';
import SidebarView from '../../components/SidebarView';
let moment = require('jalali-moment');
export default class MainCalendarView extends React.Component {

    state = {
        currentCalendar: new Calendar(),
        currentCalendarView: 'week',
        calenderTypeViews: [
            { label: 'Day', key: "day" },
            { label: 'Week', key: "week" },
            { label: 'Month', key: "month" },
        ],
        // headers: [
        //     { key: "schedule", type: "DateTimeInput", information: { label: "{{lang}}Schedule", disabled: true } },
        //     { key: "features", type: "TextInput", information: { label: "{{lang}}Applet", placeholder: "{{lang}}Text Input", disabled: true } },
        //     { key: "participants", type: "GlobalUserMultiInput", information: { label: "{{lang}}Participants", address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, disabled: true } },
        // ],
        activeAppointment: false,

        showview: false,

        // view: { settings: { stacked: { date: 'schedule', viewKey: 'schedule', row: 'schedule' } } },
        // tasks: [],
        frame: {},

        // chartOption: {
        //     legend: {
        //         display: false
        //     },
        //     responsive: true,
        //     maintainAspectRatio: false
        // },

        // data: {
        //     labels: ['Done', "Not Done"],
        //     datasets: [{
        //         data: [1, 2],
        //         backgroundColor: ['#ee5050', '#007aff']
        //     }]

        // },

        // addList: [
        //     { label: 'File', icon: '/assets/icons/useful/clip.svg', },
        //     { label: 'Drive', icon: '/assets/icons/useful/save.png', },
        //     { label: 'Editor', icon: '/assets/icons/useful/text.svg', },
        //     { label: 'Voice', icon: '/assets/icons/useful/microphone.svg', },

        // ],
        // currentTab: 0,
        // isOpen: false,
        // startOfMonth: '',
        // endOfMonth: '',
        // week: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
        // days: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,],
        // month: { startDay: 0, daysCount: 30 },
        // monthFromNow: 0,
        // today: '',
        // months: [
        //     { title: 'January' },
        //     { title: 'February' },
        //     { title: 'March' },
        //     { title: 'April' },
        //     { title: 'May' },
        //     { title: 'June' },
        //     { title: 'July' },
        //     { title: 'August' },
        //     { title: 'September' },
        //     { title: 'October' },
        //     { title: 'November' },
        //     { title: 'December' },
        // ],
        // years: [],
        // dateObject: moment(),
        // key: 'TEpyxZL1neC2JBZViuDaJ'
    }




    componentDidMount() {


        this.setState({ title: this.props.title, today: new Date().getTime() })
        // console.log('dataCal===', this.props.data)
        // window.addEventListener('resize', this.changeWidth);
        // setTimeout(() => {
        //     this.changeWidth()
        // }, 100);

        // if (this.props.title) {
        //     this.setMonth(0, this.props.title)

        // } else {
        //     this.setMonth(0)
        // }

        // let filter = {
        //     // title: { key: 'title', value: 'Antbuildz', operator: 'contains', icase: false }
        // }

        // getDBData('desk', filter, {}, (dbResult) => {
        //     this.setState({ tasks: dbResult }, () => {
        //         // this.getMyTasks()
        //     })
        // })

        // window.addEventListener("keydown", this.keyPress)
        // setTimeout(() => {
        this.state.currentCalendar.init(this)
        this.init()

        // }, 10);


    }


    componentDidUpdate(prevProps, prevState) {
    }



    init() {

        HttpServices.request('getUserCalenders', {}, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }


            // console.log("INIT AAMAIN",fetchResult.info)
            let keys = fetchResult.info.frame?.views[0]?.settings?.stacked
            let data = fetchResult.info.records
            let selectedRange = []
            let view = fetchResult.info.frame?.views[0]
            let days = {}

            // console.log('dadadada', data)
            // console.log('keys?.date', keys?.date)
            // console.log(keys?.date)

            if (keys?.date) {

                data.forEach(element => {

                    let day = getObject(element, keys?.date)
                    if (day) {
                        let key = moment(day).format("YYYY-MM-D")

                        if (!days[key]) {
                            days[key] = []
                        }

                        days[key].push(element)

                    }
                });

            }


            console.log(view)


            this.setState({ daysData: days, data, frame: fetchResult.info.frame, view })
        })
    }




    // changeMonth(number) {
    //     this.setMonth(this.state.monthFromNow + number)
    //     this.setState({ monthFromNow: this.state.monthFromNow + number })
    // }

    // setMonth(fromNow, startDate) {


    //     let now = new Date();
    //     let days = []

    //     let start = moment(now).startOf('month').add(fromNow, 'month').startOf('month')

    //     if (startDate) {
    //         start = moment(startDate).add(fromNow, 'month').startOf('month')

    //     }


    //     console.log(moment(now).add(fromNow, 'month').daysInMonth())

    //     for (let i = 0; i < moment(now).add(fromNow, 'month').daysInMonth(); i++) {

    //         days.push({ start: moment(start).add(i, 'day').startOf('day').valueOf(), end: moment(start).add(i, 'day').endOf('day').valueOf() })

    //     }

    //     let newDate = [Number(moment(start).format('YYYY')), moment(start).format('M') - 1, 1]

    //     this.setState({ month: { title: moment(start).format('YYYY-MMMM'), month: moment(start).format('MMMM'), monthNumber: moment(start).format('M') - 1, year: Number(moment(start).format('YYYY')), startDay: start.day(), days: days } }, () => {


    //     })

    // }

    // setDay(day, dayNumber) {

    //     this.setState({ title: day.start })
    //     this.props.onChange(this.props.headerkey, { type: 'changeDay', newDay: day.start, dayNumber })

    // }
    // changeWeek() {
    //     this.setState({ startDay: this.state.month.startDay })

    // }
    // showDays() {
    //     let week = []
    //     let weeks = []
    //     let days = []
    //     let startDay = this.state.month.startDay
    //     let count = 0

    //     for (let i = 0; i < startDay - 1; i++) {
    //         days.push(null)
    //     }
    //     if (!this.state.month.days) {
    //         return
    //     }
    //     days = [...days, ...this.state.month.days]
    //     console.log(this.state.month.days);

    //     for (let i = 0; i < days.length; i++) {
    //         count++
    //         week.push(days[i])
    //         if (count == 7 || i == days.length - 1) {
    //             weeks.push(week)
    //             count = 0
    //             week = []
    //         }
    //     }
    //     let lastWeekLenght = weeks[weeks.length - 1].length
    //     if (lastWeekLenght < 7) {
    //         for (let i = 0; i < 7 - lastWeekLenght; i++) {

    //             weeks[weeks.length - 1].push(null)
    //         }
    //     }
    //     count = 0
    //     return (
    //         <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }} className="Weeks">
    //             {weeks.map((week, index) => {
    //                 return (

    //                     <div key={index} className="d-flex text-center pld-2 prd-2 w-100" style={{ justifyContent: 'space-between', flexDirection: "row" }}>
    //                         {week.map((day, index1) => {

    //                             if (day == null) {
    //                                 return (
    //                                     <div key={index1} style={{ textTransform: 'uppercase', width: '100%', margin: -1, border: '1px solid transparent' }}>
    //                                     </div>
    //                                 )
    //                             } else {
    //                                 count++
    //                                 let dayNumber = count

    //                                 let isToday = (this.state.today >= day.start && this.state.today <= day.end) ? true : false
    //                                 let selectedDay = (this.state.title >= day.start && this.state.title <= day.end) ? true : false
    //                                 return (
    //                                     <div onClick={() => this.setDay(day, dayNumber)} key={index1} style={{ overflow: 'hidden', cursor: 'pointer', width: '100%', backgroundColor: selectedDay ? '#e2e8ea' : '#fcfcfc', padding: 0, borderRadius: " 50%", width: "100%", minHeight: 80, justifyContent: 'center', alignItems: 'center', display: 'flex', border: '1px solid #eee', margin: -1 }}>
    //                                         <div style={{ backgroundColor: isToday ? '#00206010' : 'transparent', borderRadius: "50%", padding: "10px 10px", width: "100%", display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
    //                                             <p style={{ color: selectedDay ? '#789' : '#789', fontSize: 12, fontWeight: 'bold' }}>{count}</p>
    //                                             {/* {count % 2 == 0 && ( */}
    //                                             <div className="flexcc w-100 flex-column">
    //                                                 {this.props.data && Array.isArray(this.props.data[count]) && (
    //                                                     <div className="w-100 text-center" style={{ overflow: 'hidden', backgroundColor: '#42BECA', padding: '5px 5px', borderRadius: 4, marginTop: 3 }}>
    //                                                         <p style={{ fontSize: 11, color: '#fff', }}>{this.props.data[count].length}{this.state.width > 550 ? " EVENTS" : ''}</p>
    //                                                         {/* <p style={{ fontSize: 11, color: '#101010', }}>{"RO-123"}</p> */}
    //                                                     </div>
    //                                                 )}

    //                                                 {this.state.width > 550 && (!this.props.data || !Array.isArray(this.props.data[count]) || this.props.data[count].length == 0) && (
    //                                                     <p className='mt-2' style={{ fontSize: 12, color: '#bcd' }}>NO DATA</p>
    //                                                 )}
    //                                             </div>
    //                                             {/* )} */}
    //                                         </div>
    //                                     </div>
    //                                 )
    //                             }
    //                         })
    //                         }

    //                     </div>

    //                 )
    //             })
    //             }
    //         </div>)
    // }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.closeBox);
        window.removeEventListener('resize', this.changeWidth);
        window.removeEventListener("keydown", this.keyPress);
    }

    openBox() {
        document.addEventListener('mousedown', this.closeBox);
        this.setState({ isOpen: true })
    }


    changeWidth = () => {
        if (this.calender) {
            let width = this.calender.getBoundingClientRect().width
            this.setState({ width })
        }
    }

    closeBox = (event) => {
        // if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
        setTimeout(() => {
            this.setState({ showMonths: false, showYears: false })
        }, 300);
        document.removeEventListener('mousedown', this.closeBox);
        //     if (this.refs.icon)
        //         this.refs.icon.classList.toggle("rotate-180")

        // }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    // conditionalSettings(param, condition) {
    //     if (this.props.settings) {
    //         if (this.props.settings[param] == condition) {
    //             return true
    //         }
    //     }
    //     return false
    // }


    showMonths = () => {
        this.setState({ showMonths: true, showYears: false })
        document.removeEventListener('mousedown', this.closeBox);
        setTimeout(() => {
            document.addEventListener('mousedown', this.closeBox);
        }, 500);

    }

    showYears = () => {
        let startYear = 2019
        let endYear = Number(moment().year())
        let years = []

        for (var i = startYear; i <= endYear; i++) {
            years.push(i);
        }

        this.setState({ showMonths: false, showYears: true, years })
        document.removeEventListener('mousedown', this.closeBox);
        setTimeout(() => {
            document.addEventListener('mousedown', this.closeBox);
        }, 500);

    }


    // setNewDate = (type, prop, index) => {
    //     let oldDate = [this.state.month.year, this.state.month.monthNumber, 1]
    //     let newDate = [this.state.month.year, this.state.month.monthNumber, 1]

    //     if (type == 'month') {
    //         newDate[1] = index
    //     }
    //     if (type == 'year') {
    //         newDate[0] = prop
    //     }

    //     // console.log(newDate)

    //     // let oldDate = []//this.state.month.title.split('-')
    //     // oldDate.push(1)

    //     // oldDate[1] = moment().month(oldDate[1]).format("M");
    //     // console.log(oldDate)
    //     // 
    //     // console.log(moment(newDate).valueOf())


    //     let monthsDiff = moment(newDate).startOf('month').diff(moment(new Date()).startOf('month'), 'months', true)

    //     // console.log(monthsDiff)
    //     if (this.props.title) {
    //         this.setMonth(monthsDiff, this.props.title)

    //     } else {
    //         this.setMonth(monthsDiff)
    //     }
    //     // console.log(monthsDiff)
    // }


    nextStage = (cb) => {
        // this.setState({ isLoading: true, errors: {} })
        if (this.form) {
            let data = this.form.getForm()
            if (data) {
                this.props.setData(data, () => {
                    // this.props.postUserInfo((result, err) => {
                    // if (err) { this.setState({ errors: err }) }
                    // this.setState({ isLoading: false })
                    this.props.chooseNextPage()

                    // })
                })
            }
        }

    }


    changeTab = (prop, index) => {
        this.setState({ currentTab: index, activeAppointment: false, showview: false })
        this.stageManager.changeStage(prop.key)
    }
    changeAppointment = (prop) => {
        this.setState({ activeAppointment: !this.state.activeAppointment, currentTab: null })
        this.stageManager.changeStage(prop.key)
    }



    keyPress = (e) => {
        if ((e.ctrlKey || e.metaKey) && e?.key == 'n') {
            this.addClicked()
            // this.hideModal()
        }
    }
    changePage = (item) => {
        this.setState({ currentPage: item.key })
    }
    // getMyTasks = () => {


    //     this.setState({ isLoadingData: true })

    //     HttpServices.request('getMyTasks', {}, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingData: false })


    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.fetchDataFailed', description: fetchError.message })
    //             return
    //         }
    //         console.log('calender', fetchResult)

    //         inserDBtData('desk', fetchResult.info)


    //         this.setState({ tasks: fetchResult.info }, () => {
    //             console.log('tasks===', this.state.tasks);
    //         })

    //     })

    // }


    // postTask = (data, cb) => {
    //     let body = data
    //     HttpServices.request('addTask', body, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingData: false })
    //         console.log(fetchError)
    //         console.log(fetchResult)

    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
    //             cb(null, fetchError)
    //             return
    //         }
    //         playSound('newMessage')
    //         this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
    //         cb(fetchResult.info)
    //     })
    // }

    // taskDone = (item) => {
    //     let tasks = this.state.tasks

    //     let stage = '1'

    //     this.changeTaskStage(item._id, stage, () => {
    //         tasks.forEach((task, index) => {
    //             if (item._id == task._id) {
    //                 tasks[index].done = !item.done
    //             }
    //         });
    //     })

    //     this.setState({ tasks })
    // }


    // changeTaskStage = (_id, stage, cb) => {

    //     let body = { _id, stage }

    //     HttpServices.request('changeTaskStage', body, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingData: false })

    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
    //             cb(null, fetchError)
    //             return
    //         }
    //         playSound('newMessage')
    //         this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
    //         cb(fetchResult.info)
    //     })

    // }


    showInfo = (item) => {
        let data = item

        this.setState({ currentData: data, sideOpen: true, showConfig: false }, () => {
            this.setState({ showConfig: true })
        })

        // this.addModal.showModal()
    }

    closeSidebar = () => {
        this.setState({ sideOpen: false })
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    addClicked = (open) => {
        // let data = {priority:'high', timeline: 'Pouya Pezhman' }
        // this.setState({ currentData: data, sideOpen: open != null ? open : true, showConfig: false }, () => {
        //     this.setState({ showConfig: true })
        // })
        // console.log(this.addTaskModal)
        this.addTaskModal.modal.showModal()
    }

    openUnscheduled = () => {
        this.unscheduledSidebar.open()
    }


    changeCalendarView = (prop) => {
        this.setState({ currentCalendarView: prop.key })
        this.stageManager.changeStage(prop.key)

        // TO DO: Send on socket and load later
    }


    // openSidebar = () => {
    //     // console.log('open side bar')
    //     this.sidebarView.openSidebar()
    // }

    // setCalendar = (calendar) => {
    //     this.setState({ CurrentCalendar: calendar })
    // }


    render() {


        return (

            <div className=" w-100 h-100 scroll-no-scrollbar" style={{}}>



                <div className='d-flex w-100 h-100'>

                    <Responsive width={'100%'} height="100%" media={{ xs: "12", sm: '12', md: '8', lg: "9", xl: "9" }}>


                        <div className='flexcb px-2 py-2' style={{ borderBottom: '1px solid #eee' }} >

                            <div className='flexc flex-1'>

                                <div className='prd-2' style={{ borderRight: '1px solid #eee' }}>
                                    <button onClick={() => this.state.currentCalendar.goToToday()} className='note-hover-box2 px-2 flexc py-1 br-5'>
                                        <p className='font-size-14 text-semibold ' style={{ color: this.state.currentCalendar?.activeDay?.key == this.state.currentCalendar?.today?.key ? 'rgb(86, 84, 214)' : null }}>{translate("Today")}</p>
                                    </button>
                                </div>
                                <div className=' px-1 flexc'>
                                    {this.state.calenderTypeViews.map((prop, index) => {
                                        return (
                                            <button className='px-2 flexc py-1 my-1 note-hover-box2 w-100 h-100 br-5' onClick={() => this.changeCalendarView(prop)}>
                                                <p className='font-size-14 text-semibold ' style={{ color: this.state.currentCalendarView == prop.key ? 'rgb(86, 84, 214)' : null }}>{prop.label}</p>
                                            </button>
                                        )
                                    })}
                                </div>

                            </div>


                            <div className='flexcc flex-1'>
                                {/* <button className='flexcc rotate-180'>
                                    <img src='/assets/icons/angle-right.svg' height={20} />
                                </button> */}

                                <div className='flexc'>

                                    <CalendarSelectScope setCalendar={this.setCalendar} currentCalendar={this.state.currentCalendar} currentCalendarView={this.state.currentCalendarView} />
                                    {/* <p className='text-normal px-1 text-bold'>August, 2023</p> */}

                                </div>

                                {/* <button className='flexcc'>
                                    <img src='/assets/icons/angle-right.svg' height={20} />
                                </button> */}

                            </div>

                            <div className='flex-1 flexc justify-content-end px-2'>

                                <button onClick={() => this.openUnscheduled()} className='flexc px-1 '>
                                    <p className='font-size-13 text-semibold'>{translate("Unscheduled")}</p>
                                </button>

                                {/* <div className='flexcc'>
                                    <button className='flexcc'>
                                        <img src="/assets/icons/bm__dots.png" height={15} />
                                    </button>
                                </div> */}
                            </div>

                        </div>

                        <StagesManager ref={el => this.stageManager = el} fast={true}>
                            <CalendarDailyView stage={1} stageName={'day'} currentCalendar={this.state.currentCalendar} view={this.state.view} daysData={this.state.daysData} functionsHandler={this.props.functionsHandler} headers={this.state.frame.fields} actions={this.props.actions} />
                            <Week data={this.state.data} submitForm={this.props.submitForm} stage={0} stageName={'week'} currentCalendar={this.state.currentCalendar} view={this.state.view} daysData={this.state.daysData} functionsHandler={this.props.functionsHandler} headers={this.state.frame.fields} actions={this.props.actions} />
                            <Month data={this.state.data} submitForm={this.props.submitForm} stage={2} stageName={'month'} currentCalendar={this.state.currentCalendar} view={this.state.view} daysData={this.state.daysData} functionsHandler={this.props.functionsHandler} headers={this.state.frame.fields} actions={this.props.actions} />
                        </StagesManager>

                    </Responsive>
                </div>




                <SidebarView width={this.props.width} ref={el => this.unscheduledSidebar = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '50%', lg: "40%", xl: "30%" }} onClose={this.onClose} >
                    <p>Test</p>

                </SidebarView>


            </div>
        )
    }
}